/**
 * Web basemap — OpenFreeMap vector (Positron), mobil ile aynı stil.
 */
export const MAP_STYLE_URL = "https://tiles.openfreemap.org/styles/positron";
export const MAP_LAND_COLOR = "#f8f9f7";
export const MAP_WATER_COLOR = "#bdd6ea";

export const MAP_ATTRIBUTION =
  '&copy; <a href="https://openfreemap.org">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';

function setPaint(map, id, prop, val) {
  try {
    if (map.getLayer(id)) map.setPaintProperty(id, prop, val);
  } catch (e) {}
}

function setLayout(map, id, prop, val) {
  try {
    if (map.getLayer(id)) map.setLayoutProperty(id, prop, val);
  } catch (e) {}
}

/** MapLibre `load` sonrası paint/layout — mobil Grab tonlarıyla aynı. */
export function applyGrabBasemap(map) {
  if (!map) return;

  const WATER = MAP_WATER_COLOR;
  const LAND = MAP_LAND_COLOR;
  const PARK = "#e8ede7";
  const IL_COLOR = "#3d4450";
  const ILCE_COLOR = "#8a9199";

  setPaint(map, "background", "background-color", LAND);
  setPaint(map, "water", "fill-color", WATER);
  setPaint(map, "waterway", "line-color", WATER);
  setPaint(map, "park", "fill-color", PARK);
  setPaint(map, "landcover_wood", "fill-color", "#e4ebe3");
  setPaint(map, "landuse_residential", "fill-color", LAND);
  setPaint(map, "building", "fill-color", "#ecece8");
  setPaint(map, "building", "fill-outline-color", "#e0e0dc");
  setPaint(map, "road_area_pier", "fill-color", LAND);
  setPaint(map, "road_pier", "line-color", LAND);

  setLayout(map, "boundary_disputed", "visibility", "none");
  setLayout(map, "boundary_2", "visibility", "visible");
  setPaint(map, "boundary_2", "line-color", "#9aa3ad");
  setPaint(map, "boundary_2", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    0,
    0.35,
    4,
    0.55,
    8,
    0.65,
  ]);
  setPaint(map, "boundary_2", "line-width", [
    "interpolate",
    ["linear"],
    ["zoom"],
    3,
    0.8,
    5,
    1.1,
    10,
    1.6,
  ]);
  setLayout(map, "boundary_3", "visibility", "none");
  try {
    map.setLayerZoomRange("boundary_3", 2, 24);
  } catch (e) {}
  setPaint(map, "boundary_3", "line-color", "#8b959e");
  setPaint(map, "boundary_3", "line-dasharray", [1, 0]);
  setPaint(map, "boundary_3", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    5,
    0.42,
    7,
    0.5,
    10,
    0.58,
    13,
    0.65,
  ]);
  setPaint(map, "boundary_3", "line-width", [
    "interpolate",
    ["linear"],
    ["zoom"],
    5,
    0.85,
    8,
    1.1,
    12,
    1.4,
  ]);

  ["label_city", "label_city_capital", "label_state"].forEach((id) => {
    setLayout(map, id, "text-font", ["Noto Sans Regular"]);
    setPaint(map, id, "text-color", IL_COLOR);
    setPaint(map, id, "text-halo-color", "rgba(255,255,255,0.9)");
    setPaint(map, id, "text-halo-width", 1.15);
    setPaint(map, id, "text-opacity", [
      "interpolate",
      ["linear"],
      ["zoom"],
      4.5,
      0,
      5.5,
      0.72,
      7.5,
      0.9,
      11,
      0.95,
    ]);
  });
  ["label_town", "label_village", "label_other"].forEach((id) => {
    setLayout(map, id, "text-font", ["Noto Sans Regular"]);
    setPaint(map, id, "text-color", ILCE_COLOR);
    setPaint(map, id, "text-halo-color", "rgba(255,255,255,0.78)");
    setPaint(map, id, "text-halo-width", 0.85);
    setPaint(map, id, "text-opacity", [
      "interpolate",
      ["linear"],
      ["zoom"],
      6,
      0,
      7.5,
      0.42,
      9.5,
      0.58,
      12,
      0.68,
    ]);
  });
  ["label_country_1", "label_country_2", "label_country_3"].forEach((id) => {
    setLayout(map, id, "visibility", "none");
  });
  ["label_village", "label_town", "label_city", "label_city_capital"].forEach(
    (id) => {
      setLayout(map, id, "icon-image", "");
      setLayout(map, id, "icon-size", 0);
      setLayout(map, id, "text-anchor", "center");
      setLayout(map, id, "text-offset", [0, 0]);
    },
  );
  setLayout(map, "label_other", "text-size", [
    "interpolate",
    ["linear"],
    ["zoom"],
    8,
    8,
    12,
    9,
  ]);
  setLayout(map, "label_village", "text-size", [
    "interpolate",
    ["exponential", 1.2],
    ["zoom"],
    8,
    8.5,
    12,
    9.5,
  ]);
  setLayout(map, "label_town", "text-size", [
    "interpolate",
    ["exponential", 1.2],
    ["zoom"],
    7,
    9,
    11,
    10.5,
  ]);
  setLayout(map, "label_state", "text-size", [
    "interpolate",
    ["linear"],
    ["zoom"],
    5,
    10,
    8,
    12,
  ]);
  setLayout(map, "label_city", "text-size", [
    "interpolate",
    ["exponential", 1.2],
    ["zoom"],
    5,
    11,
    8,
    13,
    12,
    15,
  ]);
  setLayout(map, "label_city_capital", "text-size", [
    "interpolate",
    ["exponential", 1.2],
    ["zoom"],
    5,
    12,
    8,
    14,
    12,
    16,
  ]);

  ["water_name_point_label", "water_name_line_label", "waterway_line_label"].forEach(
    (id) => {
      setLayout(map, id, "text-font", ["Noto Sans Italic"]);
      setLayout(map, id, "text-size", 10);
      setPaint(map, id, "text-color", "#7a93a8");
      setPaint(map, id, "text-opacity", 0.4);
    },
  );

  ["highway-name-path", "highway-name-minor", "highway-name-major"].forEach(
    (id) => {
      setLayout(map, id, "text-size", [
        "interpolate",
        ["linear"],
        ["zoom"],
        13,
        9,
        15,
        11,
      ]);
      setPaint(map, id, "text-opacity", 0.45);
      setPaint(map, id, "text-color", "#9aa3ad");
    },
  );
  setLayout(map, "airport", "text-size", 10);
  setPaint(map, "airport", "text-opacity", 0.5);

  setPaint(map, "highway_major_inner", "line-color", "#ffffff");
  setPaint(map, "highway_major_inner", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    11,
    0.92,
    13,
    1,
    16,
    1,
  ]);
  setPaint(map, "highway_major_inner", "line-width", [
    "interpolate",
    ["exponential", 1.3],
    ["zoom"],
    10,
    2.2,
    12,
    3.2,
    14,
    5,
    18,
    16,
    20,
    22,
  ]);
  setPaint(map, "highway_major_casing", "line-color", "#c8cdc8");
  setPaint(map, "highway_major_casing", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    11,
    0.55,
    13,
    0.7,
    15,
    0.85,
  ]);
  setPaint(map, "highway_major_casing", "line-width", [
    "interpolate",
    ["exponential", 1.3],
    ["zoom"],
    10,
    3.4,
    12,
    4.6,
    14,
    7,
    18,
    20,
    20,
    26,
  ]);
  setPaint(map, "highway_major_subtle", "line-color", "#ffffff");
  setPaint(map, "highway_major_subtle", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    7,
    0.35,
    9,
    0.55,
    11,
    0.7,
  ]);
  setPaint(map, "highway_major_subtle", "line-width", [
    "interpolate",
    ["linear"],
    ["zoom"],
    7,
    1.2,
    9,
    1.8,
    11,
    2.4,
  ]);

  setPaint(map, "highway_motorway_inner", "line-color", "#ffffff");
  setPaint(map, "highway_motorway_inner", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    11,
    0.92,
    13,
    1,
    16,
    1,
  ]);
  setPaint(map, "highway_motorway_inner", "line-width", [
    "interpolate",
    ["exponential", 1.3],
    ["zoom"],
    10,
    2.2,
    12,
    3.2,
    14,
    5,
    18,
    16,
    20,
    22,
  ]);
  setPaint(map, "highway_motorway_casing", "line-color", "#c8cdc8");
  setPaint(map, "highway_motorway_casing", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    11,
    0.55,
    13,
    0.7,
    15,
    0.85,
  ]);
  setPaint(map, "highway_motorway_casing", "line-width", [
    "interpolate",
    ["exponential", 1.3],
    ["zoom"],
    10,
    3.4,
    12,
    4.6,
    14,
    7,
    18,
    20,
    20,
    26,
  ]);
  try {
    map.setLayerZoomRange("highway_motorway_inner", 11, 24);
    map.setLayerZoomRange("highway_motorway_casing", 11, 24);
    map.setLayerZoomRange("highway_motorway_bridge_inner", 11, 24);
    map.setLayerZoomRange("highway_motorway_bridge_casing", 11, 24);
    map.setLayerZoomRange("tunnel_motorway_inner", 11, 24);
    map.setLayerZoomRange("tunnel_motorway_casing", 11, 24);
    map.setLayerZoomRange("highway_motorway_subtle", 24, 24);
  } catch (e) {}
  setLayout(map, "highway_motorway_subtle", "visibility", "none");

  ["highway_motorway_bridge_inner", "tunnel_motorway_inner"].forEach((id) => {
    setPaint(map, id, "line-color", "#ffffff");
    setPaint(map, id, "line-opacity", [
      "interpolate",
      ["linear"],
      ["zoom"],
      11,
      0.92,
      13,
      1,
      16,
      1,
    ]);
    setPaint(map, id, "line-width", [
      "interpolate",
      ["exponential", 1.3],
      ["zoom"],
      10,
      2.2,
      12,
      3.2,
      14,
      5,
      18,
      16,
      20,
      22,
    ]);
  });
  ["highway_motorway_bridge_casing", "tunnel_motorway_casing"].forEach((id) => {
    setPaint(map, id, "line-color", "#c8cdc8");
    setPaint(map, id, "line-opacity", [
      "interpolate",
      ["linear"],
      ["zoom"],
      11,
      0.55,
      13,
      0.7,
      15,
      0.85,
    ]);
    setPaint(map, id, "line-width", [
      "interpolate",
      ["exponential", 1.3],
      ["zoom"],
      10,
      3.4,
      12,
      4.6,
      14,
      7,
      18,
      20,
      20,
      26,
    ]);
  });

  try {
    map.setLayerZoomRange("highway_minor", 14.2, 24);
  } catch (e) {}
  setPaint(map, "highway_minor", "line-color", "#e4e5e2");
  setPaint(map, "highway_minor", "line-opacity", [
    "interpolate",
    ["linear"],
    ["zoom"],
    14.2,
    0.25,
    15,
    0.45,
    16.5,
    0.7,
  ]);
  setPaint(map, "highway_minor", "line-width", [
    "interpolate",
    ["exponential", 1.4],
    ["zoom"],
    14,
    0.6,
    16,
    1.2,
    18,
    4,
  ]);
  setPaint(map, "landuse_residential", "fill-color", LAND);
  setPaint(map, "landuse_residential", "fill-opacity", 0.2);

  [
    "railway",
    "railway_dashline",
    "railway_service",
    "railway_service_dashline",
    "railway_transit",
    "railway_transit_dashline",
    "highway_path",
    "highway-name-path",
  ].forEach((id) => {
    setLayout(map, id, "visibility", "none");
  });
}
